import { FormattedMessage } from 'react-intl'
import Text from 'components/shared/Text'
import Info from 'components/shared/Info'
import BlackWeekendUnlimitedDiscountsModal from 'components/shared/Promotions/components/BlackWeekendUnlimitedDiscountsModal'
import { BlackWeekendUnlimitedInfoWrapper } from './styles'
import { darkMode } from 'styles/theme'
import { BLACK_WEEKEND_REGULATIONS_LINK } from 'constants/links'
import { useState } from 'react'

const BlackWeekendUnlimitedInfo = () => {
    const [isPricingModalOpened, setIsPricingModalOpened] = useState(false)

    const handleTogglePricingModal = () =>
        setIsPricingModalOpened(!isPricingModalOpened)

    const PromoInfo = (
        <Text variant="bodySmall" color="grayscale_400">
            <FormattedMessage
                id="promo.black_weekend.unlimited_promo_info"
                defaultMessage="Użyj kodu <span>BLACKWEEKEND</span> i kup kartę Unlimited lub Unlimited+ <span>10% taniej</span>. Zniżka naliczy się po wprowadzeniu kodu rabatowego w podsumowaniu zakupu."
                description="Keep the html tags in the translation"
                values={{
                    span: (chunks: string[]) => (
                        <>
                            <Text
                                as="span"
                                variant="bodySmall"
                                color="primary_500"
                            >
                                {chunks}
                            </Text>
                        </>
                    ),
                }}
            />
        </Text>
    )
    const RegulationsLink = (
        <Text
            as="a"
            href={BLACK_WEEKEND_REGULATIONS_LINK}
            target="_blank"
            variant="bodySmall"
            isUnderlined
            color="grayscale_400"
        >
            <FormattedMessage
                id="promo.black_weekend.regulations_link"
                defaultMessage="Regulamin promocji"
            />
        </Text>
    )

    return (
        <BlackWeekendUnlimitedInfoWrapper isFullWidth mb={[16, 24]}>
            <Info color="info" hasNoBackground hasBorder theme={darkMode}>
                {PromoInfo}
                {RegulationsLink}
            </Info>
            <BlackWeekendUnlimitedDiscountsModal
                isOpened={isPricingModalOpened}
                close={handleTogglePricingModal}
            />
        </BlackWeekendUnlimitedInfoWrapper>
    )
}

export default BlackWeekendUnlimitedInfo
